const END_AGE = "1000";

export const setAge = (age, idx) => {
  if (age.includes('+')) {
    return idx === 0 ? age.replace('+', '') : END_AGE;
  } else {
    return age.split('-')[idx];
  }
};
